<template>
  <div>
    <logged-in-header />
    <requests-panel></requests-panel>
    <empower-footer />
    <whats-app />
  </div>
</template>

<script>
import EmpowerFooter from "../../components/commom/EmpowerFooter";
import loggedInHeader from "../../components/commom/LoggedInHeader";
import requestsPanel from "../../components/request/RequestsPanel";
import WhatsApp from "../../components/commom/WhatsApp";

export default {
  components: {
    loggedInHeader,
    requestsPanel,
    EmpowerFooter,
    WhatsApp
  }
};
</script>
